import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StyleViewAddressBox } from "./styled";

type AddressBoxProps = {
    currentAddress: MyBrokerApi.AddressInfo;
};

const AddressBox: FC<AddressBoxProps> = ({ currentAddress }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="subTitle">{t("User.RequestAddressChange.CurrentAddress")}</div>
            <StyleViewAddressBox data-testid="report_change_address_info">
                <div>
                    <span>{t("Common.Address")}</span>
                    <span>{currentAddress.addressDetail.mainAddress}</span>
                </div>
                <div>
                    <span>
                        {t("Common.Number")}
                        {", "}
                        {t("Common.Box")}
                    </span>
                    <span>
                        {currentAddress.addressDetail.number || " - "}
                        {", "}
                        {currentAddress.addressDetail.mailBox || " - "}
                    </span>
                </div>
                <div>
                    <span>{t("Common.AdditionalAddress")}</span>
                    <span>{currentAddress.addressDetail.additionalAddress || " - "}</span>
                </div>

                <div>
                    <span>
                        {t("Common.PostalCode")}
                        {", "}
                        {t("Common.City")}
                    </span>
                    <span>
                        {currentAddress.addressDetail.postCode}
                        {", "}
                        {currentAddress.addressDetail.city}
                    </span>
                </div>
                <div>
                    <span>{t("Common.Country")}</span>
                    <span>{currentAddress.addressDetail.country.name}</span>
                </div>
            </StyleViewAddressBox>
        </>
    );
};

export default AddressBox;
